// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CreateModificationModal from "./create-modification/CreateModificationModal.bs.js";
import * as ModificationDetailModal from "./modification-details/ModificationDetailModal.bs.js";

function getModalComponent(modalState, toggleModal) {
  var close_modal = function (param) {
    return Curry._1(toggleModal, (function (param) {
                  
                }));
  };
  if (modalState !== undefined) {
    if (modalState.TAG === /* ModificationDetails */0) {
      return React.createElement(ModificationDetailModal.make, {
                  modification: modalState.modification,
                  take_action_cb: modalState.take_action_cb,
                  close_modal: close_modal,
                  is_action_allowed: modalState.is_action_allowed
                });
    } else {
      return React.createElement(CreateModificationModal.make, {
                  close_modal: close_modal,
                  core_pricing: modalState.core_pricing
                });
    }
  } else {
    return null;
  }
}

function useModal(param) {
  var match = React.useState(function () {
        
      });
  var toggleModal = match[1];
  var modal_component = getModalComponent(match[0], toggleModal);
  var open_modal = function (modal) {
    return Curry._1(toggleModal, (function (param) {
                  return modal;
                }));
  };
  return [
          modal_component,
          open_modal
        ];
}

export {
  useModal ,
  
}
/* react Not a pure module */
